
import headerInit from './header';
import scrollingInit from './homeScrolling';
import 'slick-carousel';
import lity from 'lity';

export default function site(){
  var $ = jQuery;


  function init() {

    // $('#loader').fadeOut(300)

    headerInit($)

    $('.carousel').append(`
      <div class="carousel-item">
        <div class="relative w-full flex flex-col rounded-2xl px-4 pt-9 pb-12">
          <div class="flex flex-row justify-between mb-10">
            <div>
              <div class="mb-4">See more articles about us</div>
              <a href="newsroom" class="button inline-block small-radius">Newsroom</a>
            </div>
          </div>
        </div>
      </div>`);
    $('.carousel').slick({
      dots: true,
      appendDots: '.carousel-navigation',
      speed: 300,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      infinite: false,
    });

    scrollingInit()

    $(document).on('click', '.play-btn a', lity);

  }

  init()

}
